import { useCapabilities } from '../api/hooks'
import { useNavigationGuard } from '../components/NavigationGuard'
import { useHost } from '../host'

/**
 * Where "home" is inside the application: a supplier's or farmer's own plots,
 * otherwise the regions list, which is the dashboard. It used to be Add
 * polygons, so every way home led back into the screen people were trying to
 * leave (AG-79, AG-87).
 */
export const homeFor = (kind: 'staff' | 'supplier' | 'farmer') =>
  kind === 'supplier' ? '/farms' : kind === 'farmer' ? '/fields' : '/regions'

/**
 * Goes home, asking first if work would be lost. Embedded, the host's own
 * dashboard is home when it says how to get there (`onHome`).
 */
export function useGoHome() {
  const can = useCapabilities()
  const { onHome } = useHost()
  const { go, leave } = useNavigationGuard()
  const home = onHome ?? homeFor(can.kind)
  /** `force`: the screen has already asked, or has nothing to lose. */
  return (force?: boolean) => (force ? leave(home) : go(home))
}
